// extracted by mini-css-extract-plugin
export var container = "_57-0";
export var icon = "_57-1";
export var text = "_57-2";